import React, { useState, useEffect } from "react";
import {
  IconButton,
  Grid,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles, withStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { history } from "../../../../helpers";
import { routePaths } from "../../../config/route-paths";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  iconHeight: {
    height: "10% !important",
  },
  iconStyle: {
    padding: "0.3rem 0.3rem 0.3rem 0.5rem !important",
  },
  widthSearch: {
    width: "18vw",
  },
  fullwidthSearch: {
    width: "98%",
    marginLeft: "1%",
  },
  errorColor: {
    color: theme.palette.eDanger?.dark,
    marginTop: "0px",
    [theme.breakpoints.between("md","xl")]:{
      marginBottom:"1%"
    }
  },
  space: {
    margin: "1.1rem",
  },
}));
export const CustomOutline = withStyles({
  root: {
    borderRadius: "25px",
    minHeight: "2rem",
  },
  adornedStart: {
    paddingLeft: "0px !important",
  },
  input: {
    padding: "6px 4px 6px 1px !important",
    borderRadius: "inherit",
    backgroundColor: "none !important",
    fontSize: "14px",
  },
})(OutlinedInput);

export const CustomInputAdornment = withStyles({
  positionStart: {
    marginRight: "0px !important",
  },
})(InputAdornment);
export default function E_Searchbar({ fullWidth }) {
  const classes = useStyles();
  const [keyword, setKeyword] = useState("");
  const [error, setError] = useState(false);

  let location = useLocation();

  useEffect(() => {
    if (history?.location?.state?.word) {
      setKeyword(history?.location?.state?.word);
    } else {
      setKeyword("");
      setError(false)
    }
  }, [history?.location?.state?.word, location]);
  const {t:labels, ready: labelReady} = useTranslation("label-E_HEADER");
  const handleSearchInputChange = (e) => {
    if(e.target.value.trim().length>0){
      setKeyword(e.target.value);
      setError(false);
    }
    else{
      history.push(routePaths.HOME)
    }


  };

  const searchClickHandle = (e) => {
    e.preventDefault();
    let word = keyword?.split("");
    if (word?.length >= 3) {
      setError(false);
      history.push({
        pathname: routePaths.SEARCH_RESULTS,
        state: { word: keyword },
      });
    } else {
      setError(true);
    }
  };
  const keyPress = (e) => {
    e.preventDefault();
    if (e.key === "Enter") {
      searchClickHandle();
    }
  };

  return (
    <form>
      <CustomOutline
        id="outlined-adornment-weight"
        placeholder={labelReady ? labels?.E_SEARCH_PLACEHOLDER : ""}
        onChange={(e) => handleSearchInputChange(e)}
        value={keyword}
        autoComplete="off"
        className={fullWidth ? classes.fullwidthSearch : classes.widthSearch}
        startAdornment={
          <CustomInputAdornment position="start">
            <IconButton
              type="submit"
              onClick={searchClickHandle}
              onKeyPress={keyPress}
              className={classes.iconStyle}
            >
              <SearchIcon className={classes.iconHeight} />
            </IconButton>
          </CustomInputAdornment>
        }
      />

      {error ? (
        labelReady ?
        <FormHelperText className={classes?.errorColor}>
          {labels("E_SEARCH_ERROR")}
        </FormHelperText>
        : <Skeleton />
      ) : (
        <div className={classes.space} />
      )}
    </form>
  );
}
